import { useState } from "react";
import Kitten from "@/assets/Kitten.png";
import CheckmarkBlack from "@/assets/icons/CheckmarkBlack.svg";
import { API_URL } from "@/env";
import { showCustomToast } from "@/components/CustomToast";
import useUserData from "@/hooks/useUserData";

function Wrapper() {
  return (
    <div
      className="h-[4.709px] relative shrink-0 w-[14.891px]"
      data-name="wrapper"
    >
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 15 5"
      >
        <g id="wrapper">
          <circle
            cx="2.35449"
            cy="2.35449"
            fill="var(--fill-0, #EEEEEE)"
            id="vector"
            r="2.35449"
          />
          <circle
            cx="12.536"
            cy="2.35449"
            fill="var(--fill-0, #EEEEEE)"
            id="vector_2"
            r="2.35449"
          />
        </g>
      </svg>
    </div>
  );
}

function Wrapper1() {
  return (
    <div
      className="content-stretch flex gap-[5.473px] items-center relative shrink-0 w-full"
      data-name="wrapper"
    >
      <div className="relative shrink-0 size-[4.709px]" data-name="vector">
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 5 5"
        >
          <circle
            cx="2.35449"
            cy="2.35449"
            fill="var(--fill-0, #EEEEEE)"
            id="vector"
            r="2.35449"
          />
        </svg>
      </div>
      <div className="relative shrink-0 size-[4.709px]" data-name="vector">
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 5 5"
        >
          <circle
            cx="2.35449"
            cy="2.35449"
            fill="var(--fill-0, #EEEEEE)"
            id="vector"
            r="2.35449"
          />
        </svg>
      </div>
      <div className="relative shrink-0 size-[4.709px]" data-name="vector">
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 5 5"
        >
          <circle
            cx="2.35449"
            cy="2.35449"
            fill="var(--fill-0, #EEEEEE)"
            id="vector"
            r="2.35449"
          />
        </svg>
      </div>
    </div>
  );
}

function Wrapper2() {
  return (
    <div
      className="absolute content-stretch flex flex-col gap-[4.327px] items-center left-[calc(50%+0.16px)] top-[calc(50%+0.14px)] translate-x-[-50%] translate-y-[-50%] w-[25.072px]"
      data-name="wrapper"
    >
      <Wrapper />
      <Wrapper1 />
      <Wrapper />
    </div>
  );
}

function Wrapper3() {
  return (
    <div
      className="overflow-clip relative shrink-0 size-[36px]"
      data-name="wrapper"
    >
      <Wrapper2 />
    </div>
  );
}

function Wrapper4() {
  return (
    <div
      className="content-stretch flex items-center relative shrink-0"
      data-name="wrapper"
    >
      <Wrapper3 />
    </div>
  );
}

function Button() {
  const handleReinstall = () => {
    alert("Redirecting to extension installation...");
  };

  return (
    <button
      onClick={handleReinstall}
      className="bg-[#0377ff] content-stretch flex h-[36px] items-center px-[12px] py-0 relative rounded-[12px] shrink-0 cursor-pointer hover:bg-[#0366e6] transition-colors"
      data-name="Button"
    >
      <p className="font-medium leading-[20px] relative shrink-0 text-[#eeeeee] text-[14px] text-nowrap tracking-[-0.14px] whitespace-pre">
        Reinstall Extension
      </p>
    </button>
  );
}

function Wrapper5() {
  return (
    <div
      className="content-stretch flex items-center relative shrink-0"
      data-name="wrapper"
    >
      <Button />
    </div>
  );
}

function Wrapper6() {
  return (
    <div
      className="content-stretch flex items-center justify-between relative shrink-0 w-full"
      data-name="wrapper"
    >
      <Wrapper4 />
      <Wrapper5 />
    </div>
  );
}

function Wrapper7() {
  return (
    <div
      className="content-stretch flex flex-col font-medium gap-[12px] items-center relative shrink-0 text-center"
      data-name="wrapper"
    >
      <p className="leading-[36px] relative shrink-0 text-[28px] text-nowrap text-white tracking-[-0.28px] whitespace-pre">
        Maybe... one more chance?
      </p>
      <div className="leading-[20px] min-w-full relative shrink-0 text-[14px] text-[rgba(255,255,255,0.32)] tracking-[-0.14px] w-[min-content]">
        <p className="mb-0">
          Hopefully the Toolbar team will have a chance to help
        </p>
        <p>you with bug reports again.</p>
      </div>
    </div>
  );
}

function Wrapper8() {
  return (
    <div
      className="content-stretch flex flex-col items-center pb-[32px] pt-0 px-0 relative shrink-0"
      data-name="wrapper"
    >
      <Wrapper7 />
    </div>
  );
}

function Frame4() {
  return (
    <div className="content-stretch flex flex-col gap-[24px] items-center relative shrink-0">
      <div
        className="h-[240.14px] relative shrink-0 w-[340px]"
        data-name="imageedit_1_2959049386 1"
      >
        <img
          alt=""
          className="absolute inset-0 max-w-none object-50%-50% object-cover pointer-events-none size-full"
          src={Kitten}
        />
      </div>
      <Wrapper8 />
    </div>
  );
}

function Frame() {
  return (
    <div className="content-stretch flex flex-col  font-medium gap-[8px] items-start relative shrink-0 w-full">
      <p className="leading-[28px] relative shrink-0 text-[20px] text-white tracking-[-0.2px] w-full">
        Why did you uninstall Toolbar?
      </p>
      <p className="leading-[20px] relative shrink-0 text-[14px] text-[rgba(255,255,255,0.32)] tracking-[-0.14px] w-full">
        Check all that apply
      </p>
    </div>
  );
}

function Frame2() {
  return (
    <div className="content-stretch flex flex-col items-start relative shrink-0 w-full">
      <Frame />
    </div>
  );
}

function Checkmark({ checked }: { checked: boolean }) {
  return (
    <div className="relative shrink-0 size-[12px]" data-name="checkmark-1">
      <img src={CheckmarkBlack} />
    </div>
  );
}

function CheckboxWrapper({ checked }: { checked: boolean }) {
  return (
    <div
      className={`${
        checked ? "bg-white" : "bg-[rgba(255,255,255,0.04)]"
      } relative rounded-[6px] shrink-0 size-[20px] transition-colors`}
      data-name="wrapper"
    >
      <div
        aria-hidden="true"
        className="absolute border border-[rgba(255,255,255,0.08)] border-solid inset-0 pointer-events-none rounded-[6px]"
      />
      {checked && (
        <div className="flex justify-center items-center w-full h-full">
          <Checkmark checked={checked} />
        </div>
      )}
    </div>
  );
}

function CheckboxOption({
  label,
  checked,
  onChange,
}: {
  label: string;
  checked: boolean;
  onChange: () => void;
}) {
  return (
    <button
      onClick={onChange}
      className="bg-[rgba(255,255,255,0.04)] h-[44px] relative rounded-[16px] shrink-0 w-full hover:bg-[rgba(255,255,255,0.08)] transition-colors cursor-pointer"
      data-name="wrapper"
    >
      <div className="flex flex-row items-center size-full">
        <div className="content-stretch flex gap-[12px] h-[44px] items-center px-[16px] py-0 relative w-full">
          <CheckboxWrapper checked={checked} />
          <p className=" font-medium leading-[20px] relative shrink-0 text-[#eeeeee] text-[14px] text-nowrap tracking-[-0.14px] whitespace-pre">
            {label}
          </p>
        </div>
      </div>
    </button>
  );
}

function Wrapper21({
  selectedReasons,
  toggleReason,
}: {
  selectedReasons: Set<string>;
  toggleReason: (reason: string) => void;
}) {
  const reasons = [
    "I encountered an issue or bug",
    "Toolbar is difficult to use",
    "I have security concerns",
    "Doesn't have the feature I need",
    "I don't need it anymore",
    "Other",
  ];

  return (
    <div
      className="content-stretch flex flex-col gap-[8px] items-start relative shrink-0 w-full"
      data-name="wrapper"
    >
      {reasons.map((reason) => (
        <CheckboxOption
          key={reason}
          label={reason}
          checked={selectedReasons.has(reason)}
          onChange={() => toggleReason(reason)}
        />
      ))}
    </div>
  );
}

function Wrapper22({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div
      className="bg-[rgba(255,255,255,0.04)] relative rounded-[16px] shrink-0 w-full"
      data-name="wrapper"
    >
      <div className="flex flex-row items-center size-full">
        <div className="content-stretch flex items-center px-[16px] py-[12px] relative w-full">
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="A couple of words is enough."
            className="basis-0 no-scrollbar font-medium grow leading-[20px] min-h-[60px] min-w-px relative shrink-0 text-[14px] text-[#eeeeee] tracking-[-0.14px] bg-transparent border-none outline-none resize-none placeholder:text-[rgba(255,255,255,0.32)]"
          />
        </div>
      </div>
    </div>
  );
}

function Frame1({
  feedback,
  setFeedback,
}: {
  feedback: string;
  setFeedback: (value: string) => void;
}) {
  return (
    <div className="content-stretch flex flex-col gap-[8px] items-start relative shrink-0 w-full">
      <p className=" font-medium leading-[20px] relative shrink-0 text-[14px] text-[rgba(255,255,255,0.32)] tracking-[-0.14px] w-full">
        How can we improve Toolbar?
      </p>
      <Wrapper22 value={feedback} onChange={setFeedback} />
    </div>
  );
}

function Wrapper23({
  onSubmit,
  isLoading,
}: {
  onSubmit: () => void;
  isLoading: boolean;
}) {
  return (
    <button
      onClick={onSubmit}
      disabled={isLoading}
      className={`bg-white h-[44px] relative rounded-[16px] shrink-0 w-full transition-colors ${
        isLoading
          ? "opacity-50 cursor-not-allowed"
          : "hover:bg-[#f0f0f0] cursor-pointer"
      }`}
      data-name="wrapper"
    >
      <div className="flex flex-row items-center justify-center size-full">
        <div className="content-stretch flex h-[44px] items-center justify-center px-[16px] py-0 relative w-full">
          <p className=" font-medium leading-[20px] relative shrink-0 text-[#0f0f0f] text-[14px] text-nowrap tracking-[-0.14px] whitespace-pre">
            {isLoading ? "Submitting..." : "Submit"}
          </p>
        </div>
      </div>
    </button>
  );
}

function Frame5({
  selectedReasons,
  toggleReason,
  feedback,
  setFeedback,
  onSubmit,
  isLoading,
}: {
  selectedReasons: Set<string>;
  toggleReason: (reason: string) => void;
  feedback: string;
  setFeedback: (value: string) => void;
  onSubmit: () => void;
  isLoading: boolean;
}) {
  return (
    <div className="content-stretch flex flex-col gap-[32px] items-center pb-[40px] pt-0 px-0 relative rounded-[24px] shrink-0 w-[340px]">
      <Frame2 />
      <Wrapper21
        selectedReasons={selectedReasons}
        toggleReason={toggleReason}
      />
      <Frame1 feedback={feedback} setFeedback={setFeedback} />
      <Wrapper23 onSubmit={onSubmit} isLoading={isLoading} />
    </div>
  );
}

function Frame3({
  selectedReasons,
  toggleReason,
  feedback,
  setFeedback,
  onSubmit,
  isLoading,
}: {
  selectedReasons: Set<string>;
  toggleReason: (reason: string) => void;
  feedback: string;
  setFeedback: (value: string) => void;
  onSubmit: () => void;
  isLoading: boolean;
}) {
  return (
    <div className="basis-0 content-stretch flex gap-[160px] grow items-center justify-center min-h-px min-w-px relative shrink-0 w-full">
      <Frame4 />
      <Frame5
        selectedReasons={selectedReasons}
        toggleReason={toggleReason}
        feedback={feedback}
        setFeedback={setFeedback}
        onSubmit={onSubmit}
        isLoading={isLoading}
      />
    </div>
  );
}

export default function FeedbackPage() {
  const [selectedReasons, setSelectedReasons] = useState<Set<string>>(
    new Set()
  );
  const [feedback, setFeedback] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useUserData();

  const toggleReason = (reason: string) => {
    const newReasons = new Set(selectedReasons);
    if (newReasons.has(reason)) {
      newReasons.delete(reason);
    } else {
      newReasons.add(reason);
    }
    setSelectedReasons(newReasons);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/emails/feedback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          reasons: Array.from(selectedReasons),
          feedback: feedback,
          email: user?.email,
        }),
      });

      if (response.ok) {
        showCustomToast("Feedback sent. Thank you!", "check");
        //    alert("Thank you for your feedback!");
        // Reset form
        setSelectedReasons(new Set());
        setFeedback("");
      }
    } catch (error) {
      console.error("Error submitting feedback:", error);
      alert("Failed to submit feedback. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="onest-md relative size-full" data-name="Changelog">
      <div className="size-full">
        <div className="h-[calc(100vh-80px)]  content-stretch flex flex-col gap-[12px] items-start p-[16px] relative size-full">
          {/* <Wrapper6 /> */}
          <Frame3
            selectedReasons={selectedReasons}
            toggleReason={toggleReason}
            feedback={feedback}
            setFeedback={setFeedback}
            onSubmit={handleSubmit}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
}
